import React from 'react';
import { FolderOpen } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * EmptyState — estado vacío reutilizable para tablas y listas.
 *
 * Props:
 *   icon        — componente Lucide (por defecto FolderOpen)
 *   title       — texto principal
 *   description — texto secundario
 *   action      — { label, onClick } botón opcional
 *   className   — clases adicionales
 */
const EmptyState = ({
  icon: Icon = FolderOpen,
  title = 'No hay datos disponibles',
  description = 'Ajusta los filtros o agrega un nuevo registro',
  action,
  className,
}) => {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 px-6 text-center', className)}>
      <div className="w-14 h-14 rounded-2xl bg-slate-800 border border-slate-700/50 flex items-center justify-center mb-4 shadow-inner">
        <Icon size={26} className="text-slate-500" />
      </div>
      <p className="text-slate-300 font-semibold text-sm">{title}</p>
      <p className="text-slate-600 text-xs mt-1 max-w-xs">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold shadow-lg shadow-blue-900/20 transition-all duration-200 hover:-translate-y-0.5 active:scale-95"
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
